module.exports = __webpack_public_path__ + "img/you-mission-footer-img@3x.7c437b77.png";